/*!
 * lx-article-layout.js — v5 (2026-05-22 hotfix)
 * Pedia 記事レイアウト用グローバル JS（テーマ側）
 *   - 比較表ソート（sortProductTable）：常に bind（per-feature guard）
 *   - TOC 開閉ハンドラ：bodyHtml inline IIFE が先に bind 済みなら skip（二重バインド防止）
 *
 * v4 → v5 hotfix 概要:
 *   v4 では冒頭 `if (window.__lxArticleLayoutInit) return;` の早期 return が
 *   Metaobject `toc_script` の inline IIFE と衝突。inline が HTML パース時に
 *   同期実行で `__lxArticleLayoutInit=true` を立て、defer 属性で読み込まれる
 *   この JS が即 return → 比較表ソート handler が一度も bind されない不具合。
 *   v5 では per-feature ガードに分離し、TOC は inline と協調・sort はテーマ側専任。
 */
(function () {
  'use strict';

  // ===== TOC 開閉ハンドラ（H3 個別展開） =====
  // bodyHtml inline IIFE（Metaobject toc_script）が先に走ると
  //   window.__lxArticleLayoutInit = true
  // をセットし、TOC click delegation を自前で bind する。
  // テーマ側はそれを検知して bind を skip し、二重ハンドラを避ける。
  if (!window.__lxArticleLayoutInit && !window.__lxTocHandlerBound) {
    window.__lxTocHandlerBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.lx-toc__expand');
      if (!btn) return;
      var subId = btn.getAttribute('aria-controls');
      var sub = subId ? document.getElementById(subId) : null;
      if (!sub) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      if (open) {
        sub.setAttribute('hidden', '');
        btn.setAttribute('aria-expanded', 'false');
        btn.textContent = '+';
        var lbl = btn.getAttribute('aria-label');
        if (lbl) btn.setAttribute('aria-label', lbl.replace('閉じる', '開く'));
      } else {
        sub.removeAttribute('hidden');
        btn.setAttribute('aria-expanded', 'true');
        btn.textContent = '−';
        var lbl2 = btn.getAttribute('aria-label');
        if (lbl2) btn.setAttribute('aria-label', lbl2.replace('開く', '閉じる'));
      }
    });
  }

  // ===== 比較表ソート（独立 per-feature guard） =====
  // bodyHtml inline IIFE は sort を bind しないので、ここでは常に bind する。
  if (window.__lxSortHandlerBound) return;
  window.__lxSortHandlerBound = true;

  function getSortInfo(tr) {
    try {
      var raw = tr.getAttribute('data-sort-info');
      if (!raw) return { price: 0, recommend_score: 0 };
      return JSON.parse(raw);
    } catch (e) {
      return { price: 0, recommend_score: 0 };
    }
  }

  function sortProductTable(tableId, mode) {
    var table = document.querySelector('table[data-table-id="' + tableId + '"]');
    if (!table) return;
    var tbody = table.querySelector('tbody');
    if (!tbody) return;
    var rows = Array.prototype.slice.call(tbody.querySelectorAll('tr.product-table__row'));
    if (rows.length === 0) return;
    var sorted = rows.sort(function (a, b) {
      var ai = getSortInfo(a);
      var bi = getSortInfo(b);
      if (mode === 'price') {
        return (ai.price || 0) - (bi.price || 0);
      }
      // recommend (default, descending)
      return (bi.recommend_score || 0) - (ai.recommend_score || 0);
    });
    sorted.forEach(function (r) { tbody.appendChild(r); });
    tbody.classList.remove('sorted-descending', 'sorted-ascending');
    tbody.classList.add(mode === 'price' ? 'sorted-ascending' : 'sorted-descending');
    // ボタンの active 切り替え
    var controls = document.querySelector('.product-table-controls[data-table-id="' + tableId + '"]');
    if (controls) {
      var btns = controls.querySelectorAll('.product-table-sort-btn');
      btns.forEach(function (b) { b.classList.remove('active'); });
      var idx = mode === 'price' ? 1 : 0;
      if (btns[idx]) btns[idx].classList.add('active');
    }
  }
  window.sortProductTable = sortProductTable;

  // ソートタブのクリックを delegation で拾う
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.product-table-sort-btn');
    if (!btn) return;
    var controls = btn.closest('.product-table-controls');
    if (!controls) return;
    var tableId = controls.getAttribute('data-table-id');
    if (!tableId) return;
    var text = (btn.textContent || '').trim();
    var mode = text.indexOf('価格') !== -1 ? 'price' : 'recommend';
    sortProductTable(tableId, mode);
  });
})();
